module["exports"] = [];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ru/name/prefix.js
// module id = 2671
// module chunks = 2